import Rest from '@/services/Rest';

/**
 * @typedef {CircleService}
 */
export default class CircleService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/circle'
}
